/* eslint-disable */
import { BiPaint, BiPencil } from "react-icons/bi";
import { BsCodeSlash, BsClipboardData } from "react-icons/bs";
import { AiOutlineMail, AiFillAudio } from "react-icons/ai";
import { RiComputerLine } from "react-icons/ri";
import { ImPointUp } from "react-icons/im";
import { FaInternetExplorer, FaRegHandPointUp, FaChalkboardTeacher, FaCameraRetro, FaPinterest, FaVideo, FaTabletAlt, FaRegNewspaper, FaHandPointUp } from "react-icons/fa";
import React from "react";


export const servicesData = [

    {
        id: 1,
        title: 'Graphic Design',
        icon: <BiPaint />
    },
    {
        id: 2,
        title: 'Web Development',
        icon: <RiComputerLine />
        //  icon: <FaChalkboardTeacher />
        // icon: <BiPencil /> 
    },
    
    {
        id: 3,
        title: 'UI/UX Design',
        icon: <ImPointUp />
        // icon: <FaHandPointUp />
    },
    // {
    //     id: 4,
    //     title: 'TV Commercials',
    //     icon: <FaInternetExplorer />
    // },
    // {
    //     id: 5,
    //     title: 'Website Development',
    //     icon: <FaChalkboardTeacher />
    // },

    // {
    //     id: 6,
    //     title: 'Landing Pages',
    //     icon: <BsCodeSlash />
    // },
    // {
    //     id: 7,
    //     title: 'Photography',
    //     icon: <FaCameraRetro />
    // },
    // {
    //     id: 8,
    //     title: 'Pinterest Virtual Assistant',
    //     icon: <FaPinterest />
    // }, 
    // {
    //     id: 9,
    //     title: 'TV Commercials',
    //     icon: <FaVideo />
    // },
    // {
    //     id: 10,
    //     title: 'Data Entry', 
    //     icon: <BsClipboardData />
    // },
    // {
    //     id: 11,
    //     title: 'Ebook Writing',
    //     icon: <FaTabletAlt />
    // },
    // {
    //     id: 12,
    //     title: 'Audio Transcription',
    //     icon: <AiFillAudio />
    // },
    // {
    //     id: 13,
    //     title: 'Digital Business Cards',
    //     icon: <FaRegNewspaper />
    // },

]

// Uncomment your required service.
// Couldn't find the required services? Raise an issue on github at https://github.com/hhhrrrttt222111/developer-portfolio/issues/new
// You can also add on your own 😉.